import * as React from 'react';
import styled from 'styled-components';

import { Box } from '@origin-digital/style-guide/dist/cjs/components/Box';

import { IDiscount } from '../../models/content.interfaces';
import { InlineSvg } from '../Svg';
import { Colors } from '@origin-digital/style-guide/dist/cjs/consts/palette.const';
import { Spacing } from '@origin-digital/style-guide/dist/cjs/consts/metrics.const';
import { BREAK_POINTS, COLOURS } from '../../consts/style';

const VALUE_HEIGHT = '32px;';

const ValueContainer = styled.span`
  font-size: 24px;
  margin-right: 8px;
  color: ${COLOURS.TEXT.HEADING};

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    font-size: ${VALUE_HEIGHT};
  }
`;

export type IDiscountType = {
  iconSvg: string;
  className?: string;
  byline?: string;
};

const Icon = styled(({ className, byline, iconSvg }: IDiscountType) => (
  <InlineSvg className={className} title={byline} html={iconSvg} />
))`
  width: ${VALUE_HEIGHT};
  height: ${VALUE_HEIGHT};
  color: ${Colors.LIGHT_ORANGE};
  fill: ${Colors.LIGHT_ORANGE};
`;

interface IDiscountContainer {
  borderRight?: boolean;
  singleFuel?: boolean;
}

const DiscountContainer = styled(Box)`
  display: inline-flex;
  margin-bottom: 8px;
  height: 100%;
  ${(p: IDiscountContainer) => (p.borderRight ? `border-right: 1px Solid ${Colors.GREY16}` : '')};
  ${(p) =>
    p.borderRight && !p.singleFuel
      ? `padding-right: ${Spacing.P_X_SM}px`
      : `padding-left: ${Spacing.P_X_SM}px`};
  ${(p) => (p.singleFuel ? 'padding: 0px' : '')};

  @media (min-width: ${BREAK_POINTS.MIN.MD}) {
    ${(p) =>
      p.borderRight ? `padding-right: ${Spacing.P_X_LG}px` : `padding-left: ${Spacing.P_X_LG}px`};
    ${(p) => (p.singleFuel ? 'padding: 0px' : '')};
    margin-bottom: 24px;
  }
`;

const DisclaimerAnchor = styled.a`
  color: ${Colors.GREY};
  text-decoration: none;
`;

const DiscountExplanation = styled.div`
  padding: ${Spacing.P_Y_XS}px 0;
  font-size: 14px;
  color: ${COLOURS.PRIMARY.GREY};
  line-height: 1.71;
`;

export const DiscountItem = ({
  discountValue,
  iconSvg,
  byline,
  borderRight,
  showDisclaimer,
  singleFuel,
}: IDiscount & IDiscountContainer) => (
  <DiscountContainer
    direction="column"
    justifyContent="start"
    width={singleFuel ? '100%' : '50%'}
    height="100%"
    flex="none"
    borderRight={borderRight}
    singleFuel={singleFuel}
  >
    <Box display="flex" justifyContent="start">
      <ValueContainer>{discountValue}</ValueContainer>
      <Icon byline={byline} iconSvg={iconSvg} />
    </Box>
    <DiscountExplanation>
      {byline}
      {showDisclaimer ? (
        <>
          &nbsp;<DisclaimerAnchor href="#disclaimer">*</DisclaimerAnchor>
        </>
      ) : null}
    </DiscountExplanation>
  </DiscountContainer>
);

export const DiscountItems = ({
  discounts,
  showDisclaimer,
}: {
  discounts?: IDiscount[];
  showDisclaimer: boolean;
}) =>
  discounts && discounts.length > 0 ? (
    <Box>
      <DiscountItem
        showDisclaimer={showDisclaimer}
        {...discounts[0]}
        singleFuel={discounts.length === 1}
        borderRight={discounts.length > 1}
      />
      {discounts.length > 1 ? (
        <DiscountItem showDisclaimer={showDisclaimer} {...discounts[1]} />
      ) : null}
    </Box>
  ) : null;
